import Vue from 'vue'

Vue.filter('money', function (montant) {
    let val = (montant / 1).toFixed(2).replace('.', ",")
    if (val == '0,00') {
        return 'N/A'
    }
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " $"
})
